import React, { useState } from "react";
import { View,
   StyleSheet,
    TouchableWithoutFeedback,
     TouchableOpacity,
     Dimensions,
     Image } from "react-native";
//import { Image } from "react-native-expo-image-cache";
import { Video, AVPlaybackStatus } from 'expo-av';

import Text from "./Text";
import colors from "../config/colors";
import { MaterialCommunityIcons, Entypo, Foundation,FontAwesome5,Ionicons,AntDesign ,Fontisto, Octicons   } from "@expo/vector-icons";
import { ListItemAccount } from "./lists";
import textStyles from "../config/textStyles";

var windowWidth = Dimensions.get('window').width;
var windowHeight = Dimensions.get('window').height;

function CardFeedType({ title, 
                subTitle, 
                imageUrl, 
                onPress, 
                onPressLike,
                onPressComment, 
                onPressNumLikes, 
                thumbnailUrl,
                commentsNum,
                actionsNum,
                userPhoto,
                userName,
                seedDescription,
                type,
                onPressShare,
                followersSeed = 0
                }) { 

const video =React.useRef(null);
const [status, setStatus] = useState({});
const [verMas, setVerMas] = useState(false);
//debugger
    return (
        <View style={styles.card}>
            {/* <TouchableOpacity onPress={onPress}> */}
                             {/* <Text style={styles.actionName}> {userPhoto}</Text> */}

            {
              onPressShare&&
             <Entypo style={{ marginLeft:'80%'}} 
                     name="share"
                     size={28}
                     color="black" 
                     onPress={onPressShare} 
            />
            }
            <View style={styles.viewIconAndNameAction}>
                     {/* <View style={styles.iconOfAction0}>                          
                              <FontAwesome5                         
                                name={"seedling"} 
                                color={"#8DF78D"} 
                                size={20} 
                              />                                
                     </View>
                     <Text style={styles.actionName}> Semilla </Text> */}
                           { //pinta los titulos de las acciones
            type === 0 ?
            <>
                 <View style={styles.iconOfAction0} >
                              <FontAwesome5  
                                                      
                                name={"seedling"} 
                                color={"#8DF78D"} 
                                size={20} 
                              />
                 </View>
                 <Text style={styles.actionName}> Semilla </Text>

                </>
         :
            type === 1 ?
            <>
                 <View  style={styles.iconOfAction1}  >
                              <AntDesign  
                                                  
                              name={"infocirlceo"} 
                              color={colors.chakra1nar} 
                              size={18} 
                              onPress={ onPress }
                              /> 
                  </View>
                     <Text style={styles.actionName}> Información </Text>
            </>
         :
            type === 2 ?
            <>
                  <View   style={styles.iconOfAction2} >
                              <MaterialCommunityIcons
                                                       
                                  name={"lightbulb-on-outline"} 
                                  color={colors.chakra2ama} 
                                  size={20}
                                  onPress={ onPress } 
                                />
                  </View>
                  <Text style={styles.actionName}> Idea </Text>                  
          </>
          :
            type === 3 ?
            <>
                 <View style={styles.iconOfAction3} >
                            <Fontisto  
                                                  
                                name={"map"} 
                                color={"green"} 
                                size={16} 
                                onPress={ onPress }
                              />
                 </View>
                    <Text style={styles.actionName}> Plan </Text>
               
            </>
          :
            type === 4 ?
            <>
                 <View  style={styles.iconOfAction4}>
                        
                            <FontAwesome5   
                                                 
                                name={"people-carry"}   //tractor people-carry
                                color={"blue"} 
                                size={15} 
                                onPress={ onPress }
                              />
                  </View>       
                    <Text style={styles.actionName}> Acción </Text>
              </>
          :
            type === 5 ?
            <>
                 <View style={styles.iconOfAction5}>
                            <Octicons 
                                                        
                                name={"megaphone"} 
                                color={colors.chakra5vlt} 
                                size={20} 
                                onPress={ onPress }
                              />
                  </View>
                  <Text style={styles.actionName}> Atraer personas </Text>
            </>  
          :
          type === 6 ?
          <>
               <View  style={styles.iconOfAction6}>
                            <FontAwesome5  
                                                      
                                name={"hat-wizard"} 
                                color={colors.chakra6rsa} 
                                size={18} 
                                onPress={ onPress }
                            /> 
                </View>
                  <Text style={styles.actionName}> Hacer divertida la semilla </Text>
         </>
          :
           type === 7 ?
           <>
               <View style={styles.iconOfAction7}>
                            <Fontisto                         
                            name={"sourcetree"} 
                            color={colors.chakra7ryo} 
                            size={18} 
                          /> 
                </View>
                  <Text style={styles.actionName}> Ramificar la semilla </Text>
            </> 
          :
          null
    }  
                   {
                   onPressShare   &&
                     <Entypo    style={{ marginLeft:'55%'}}
                                name="share"
                                size={28}
                                color="grey"
                                onPress={onPressShare} 
                      />
                   }
                     
                 </View>
            <View>
              <Text style={styles.title} >
                    {title}
              </Text>

              {
                seedDescription === undefined ?
                <Text style={styles.seedDescription} >
                      No hay descripción para esta semilla 
                </Text>
                :
                seedDescription === null ?
                <Text style={styles.seedDescription} >
                      No hay descripción para esta semilla 
                </Text>
                :
                seedDescription.length > 150 ?
                <Text style={styles.seedDescription} 
                          numberOfLines={5}
                          onPress={ () => {
                              setVerMas(true)

                              console.log('ver más :) _', verMas)
                          }
                }>
                      {seedDescription.substring(0, 200)} ... ver mas
                </Text>
                :
                <Text style={styles.seedDescription} >
                      {seedDescription}
                </Text>
              }

              {  
                imageUrl.includes('.mp4') ?
                <Video 
                ref = {video}
                style = {windowWidth > 200 ? styles.imageWeb  : styles.image}
                source = {{
                  uri: imageUrl
                }}
                useNativeControls
                resizeMode = "contain"
                isLooping
                onPlaybackStatusUpdate = {status => setStatus(() => status)}
                />
                :
                imageUrl.includes('.mov') ?
                <Video 
                ref = {video}
                style = {windowWidth > 200 ? styles.imageWeb  : styles.image}
                source = {{
                  uri: imageUrl
                }}
                useNativeControls
                resizeMode = "contain"
                isLooping
                onPlaybackStatusUpdate = {status => setStatus(() => status)}
                />
                : 
                imageUrl === 'http://18.116.234.21:5001/seedImages/' ?
                <View style={styles.imageMountain} >
                            <Foundation //style={styles.imageMountain}
                                        name="mountains" 
                                        size={350} 
                                        color={colors.medium} />
                </View>
                :  
                    <Image
                      style={ windowWidth > 200 ? styles.imageWeb  : styles.image}
                      // tint="light"
                      //preview={{ uri: thumbnailUrl }}
                      //uri={imageUrl}
                      source={{ uri: imageUrl }}
                      resizeMode="contain"
                    />
                
                // <Image
                //   onPress={onPress}
                //   style={ windowWidth > 200 ? styles.imageWeb  : styles.image  }
                //   tint="light"
                //   preview={{ uri: thumbnailUrl }}
                //   uri={{ uri: thumbnailUrl }}
                // />
              }
              </View>
              <ListItemAccount         
                titleRol={userName}
                image={userPhoto}
              />
            {/* </TouchableOpacity> */}
            <View style={styles.detailsContainer}>

                 <View style={styles.likeAndCommentContainer}> 
                        <Text style={styles.subTitle} // Número de cerebros like
                              numberOfLines={2} 
                              onPress={onPressNumLikes}>
                              {subTitle}
                        </Text>
                        <Text style={styles.commentsNum} // Número de comments
                              numberOfLines={1} >
                              {commentsNum}
                        </Text>
                        <Text style={styles.actionsNum} // Número de acciones(ramas)Tree
                              numberOfLines={1} >
                              {actionsNum}
                        </Text>
                        <Text style={styles.textFollower} // Número seguidores de la semilla
                              numberOfLines={1} >
                              {followersSeed}
                        </Text>
                  </View>
                  <View style={styles.likeAndCommentContainer}> 
                        <MaterialCommunityIcons style={styles.brain}
                                                name={"brain"} 
                                                color={"red"} 
                                                size={27} 
                                                onPress={onPressLike}
                        />
                          <MaterialCommunityIcons  style={styles.comments}
                                                  name={"comment-text-outline"} 
                                                  color={"grey"} 
                                                  size={27} 
                                                  onPress={onPressComment} 
                          /> 
                          <Entypo style={styles.tree}
                                  name={"tree"}
                                  color={"grey"} 
                                  size={27} 
                                  onPress={onPress}
                          />    
                          <Ionicons  style={styles.followersSeed}
                                name="ios-people"
                                size={27} 
                                color="grey" 
                          />            
                  </View>
            </View>
      </View>
    )
 
}


const styles = StyleSheet.create({
  card: {
    borderRadius: 15,
    backgroundColor: colors.fondoGeneral,
    marginBottom: 15,
    overflow: "hidden",
    width:'94%',
    alignSelf:'center',
  },
  viewIconAndNameAction: {
    flexDirection: "row",
    alignSelf: "flex-start", 
    //backgroundColor: "blue", 
    alignItems: "center",
   // width:'60%',
    marginLeft: "3.5%",
  },
  detailsContainer: {
    padding: 10,
  },
  image: {
    width: 400,
    height: 400,
  },
  imageWeb: {
    marginLeft:'10%',
    width: '80%',
    height: 250,
  },
  // image: {
  //   marginTop: "2%",
  //   width:  (windowWidth*.500),     //120,  // Para que funcione resizeMode= "stretch" en las propiedades de ImageCache arriba tanto width como heigth deben estar en pixeles, ninguno en porcentajes.
  //   //width:   120,
  //   height: (windowHeight*.5510),    //120, 
  //   //height:  120, 
  //   backgroundColor: colors.chakra8tur,
  // },
  imageMountain: {
    width: "100%",
    height: 250,
    alignItems: "center"
  },
  likeAndCommentContainer: {
     flexDirection: "row",
     width: "100%",
     height: 20,
  },
  likes: {
    marginLeft: "20%",
 },


 comments:{
  marginLeft: "35%",
  color: colors.medium,

 },
 tree:{
  marginLeft: "35%",
  color: colors.medium,
 },
 subTitle: {
  fontSize: textStyles.textSmall,
  color: colors.medium,
  marginLeft: "10%"
},
textFollower:{
  fontSize: textStyles.textSmall,
  marginLeft: "21%",
  color: colors.medium
},
likes: {
  fontSize: 16,
  marginLeft: "14%",
  color: colors.medium
},
actionsNum:{
fontSize: textStyles.textSmall,
marginLeft: windowWidth > 600 ? "20.5%"  : "21.5%",
color: colors.medium
},
commentsNum:{
fontSize: textStyles.textSmall,
marginLeft: "20.5%",
color: colors.medium
},
title: {
    // marginBottom: 7,
    // //fontSize: 50,
    // fontWeight: "bold",
    // alignSelf: "center"
    textAlign: "justify",
    fontSize: textStyles.textMedium,
    fontWeight:'bold',
    color: colors.textGeneral,
    marginBottom: 2,
    padding:5,//(windowWidth * .97),
    alignSelf:'center',
  },
  seedDescription:{
    // marginBottom: 7,
    // textAlign: "center",

    textAlign: "justify",
    fontSize: textStyles.textSmall,
    fontWeight: textStyles.fontWeightMedium,
    color: colors.textGeneral,
    marginBottom: 2,
    padding:5,//(windowWidth * .97),
    alignSelf:'center',
  },
  iconOfAction0: { 
    height: 35,//(windowWidth * .08),   
    width: 35,//(windowWidth * .08),  
    borderRadius: 25,
    borderWidth: 4,
    borderColor: "#8DF78D",    
    alignItems: "center", 
    justifyContent: "center",
    marginBottom: "-1.2%", 
    zIndex: 1,
   // alignSelf: "flex-end",
    //marginLeft: "2%", 
   // marginRight: "2%", 
    marginTop: 3,
    backgroundColor: "#EBAB91"  
    },
    iconOfAction1: { 
      flexDirection: "row",
      height: 35,   
      width: 35,  
      borderRadius: 25,
      borderWidth: 4,
      borderColor: colors.chakra1nar,    
      alignItems: "center", 
      justifyContent: "center",
      //marginBottom: "-1.2%", 
      zIndex: 1,
      alignSelf: "flex-end", 
      marginLeft: "2%", 
      marginRight: "2%", 
     // marginTop: 3,
      backgroundColor: colors.fondoImagenes  
      },
    iconOfAction2: { 
      flexDirection: "row",
      height: 35,   
      width: 35,  
      borderRadius: 25,
      borderWidth: 4,
      borderColor: colors.chakra2ama,    
      alignItems: "center", 
      justifyContent: "center",
     // marginBottom: "-1.2%", 
      zIndex: 2,
      alignSelf: "flex-end", 
      marginLeft: "2%", 
      marginRight: "2%", 
      marginTop: 3,
      backgroundColor: colors.fondoImagenes  
      },
  iconOfAction3: { 
      flexDirection: "row",
      height: 35,   
      width: 35,  
      borderRadius: 25,
      borderWidth: 4,
      borderColor: colors.chakra3ver,    
      alignItems: "center", 
      justifyContent: "center",
      //marginBottom: "-1.2%", 
      zIndex: 2,
      alignSelf: "flex-end", 
      marginLeft: "2%", 
      marginRight: "2%", 
      marginTop: 3,
      backgroundColor: colors.fondoImagenes  
      },
  iconOfAction4: { 
      flexDirection: "row",
      height: 35,   
      width: 35,  
      borderRadius: 25,
      borderWidth: 4,
      borderColor: "blue",    
      alignItems: "center", 
      justifyContent: "center",
     // marginBottom: "-1.2%", 
      zIndex: 2,
      alignSelf: "flex-end", 
      marginLeft: "2%", 
      marginRight: "2%", 
    //  marginTop: 3,
      backgroundColor: colors.fondoImagenes  
      },
  iconOfAction5: { 
      flexDirection: "row",
      height: 35,   
      width: 35,  
      borderRadius: 25,
      borderWidth: 4,
      borderColor: colors.chakra5vlt,    
      alignItems: "center", 
      justifyContent: "center",
      //marginBottom: "-1.2%", 
      zIndex: 2,
      alignSelf: "flex-end", 
      marginLeft: "2%", 
      marginRight: "2%", 
     // marginTop: 3,
      backgroundColor: colors.fondoImagenes  
      },
  iconOfAction6: { 
      flexDirection: "row",
      height:35,   
      width: 35,  
      borderRadius: 25,
      borderWidth: 4,
      borderColor: colors.chakra6rsa,    
      alignItems: "center", 
      justifyContent: "center",
     // marginBottom: "-1.2%", 
      zIndex: 2,
      alignSelf: "flex-end", 
      marginLeft: "2%", 
      marginRight: "2%", 
     // marginTop: 3,
      backgroundColor: colors.fondoImagenes  
      },
  iconOfAction7: { 
      flexDirection: "row",
      height: 35,   
      width: 35,  
      borderRadius: 25,
      borderWidth: 4,
      borderColor: colors.chakra7ryo,    
      alignItems: "center", 
      justifyContent: "center",
    //  marginBottom: "-1.2%", 
      zIndex: 2,
      alignSelf: "flex-end", 
      marginLeft: "2%", 
      marginRight: "2%", 
      //marginTop: 3,
      backgroundColor: colors.fondoImagenes  
      },
  
    actionName: {
      fontSize: textStyles .textSmall,
      color: colors.textGeneral,
     // marginTop: "2%",
      //textAlignVertical: "bottom",
      marginBottom: "9.5%",
      marginLeft:'15%'
    },
    brain:{
      fontSize: 18,
      marginLeft: "9%",
     },
     comments:{
      fontSize: 18,
      marginLeft: "18%",
     // color: colors.medium,
    
     },
    followersSeed:{
      fontSize: 18,
      marginLeft: "18%",
      //color: colors.textGeneral,
     },
     tree:{
      fontSize: 18,
      marginLeft: "18%",
      //color: colors.textGeneral,
     },

});

export default CardFeedType;